import { input } from '@angular/core';
import * as i0 from "@angular/core";
const _forTrack0 = ($index, $item) => $item[0];
function EditPortfolioConfirmationDetailsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.details().error);
} }
function EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_1_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "li")(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const attribute_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.humanizeAttribute(attribute_r2[0]), ":");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", attribute_r2[1], " ");
} }
function EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2, "Updating:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "ul", 4);
    i0.ɵɵrepeaterCreate(4, EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_1_For_5_Template, 4, 2, "li", null, _forTrack0);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r0.details().edited_attributes);
} }
function EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_2_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "li")(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const holding_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r3[0]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(": ", holding_r3[1]);
} }
function EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2, "New holdings list after update:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "ul", 4);
    i0.ɵɵrepeaterCreate(4, EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_2_For_5_Template, 4, 2, "li", null, _forTrack0);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r0.details().new_holdings_list);
} }
function EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div");
    i0.ɵɵtext(1, "No changes proposed.");
    i0.ɵɵdomElementEnd();
} }
function EditPortfolioConfirmationDetailsComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1);
    i0.ɵɵconditionalCreate(1, EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_1_Template, 6, 0, "div", 2);
    i0.ɵɵconditionalCreate(2, EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_2_Template, 6, 0, "div", 2);
    i0.ɵɵconditionalCreate(3, EditPortfolioConfirmationDetailsComponent_Conditional_1_Conditional_3_Template, 2, 0, "div");
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().edited_attributes.length ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().new_holdings_list.length ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.details().edited_attributes.length && !ctx_r0.details().new_holdings_list.length ? 3 : -1);
} }
export class EditPortfolioConfirmationDetailsComponent {
    constructor() {
        this.details = input.required(...(ngDevMode ? [{ debugName: "details" }] : []));
    }
    humanizeAttribute(key) {
        const spaced = key.replace(/_/g, ' ');
        return spaced.charAt(0).toUpperCase() + spaced.slice(1);
    }
}
EditPortfolioConfirmationDetailsComponent.ɵfac = function EditPortfolioConfirmationDetailsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditPortfolioConfirmationDetailsComponent)(); };
EditPortfolioConfirmationDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditPortfolioConfirmationDetailsComponent, selectors: [["ycn-edit-portfolio-confirmation-details"]], inputs: { details: [1, "details"] }, decls: 2, vars: 1, consts: [[1, "text-large", "leading-relaxed", "mb-3", "text-danger"], [1, "text-large", "leading-relaxed", "mb-3"], [1, "mt-2"], [1, "text-bold"], [1, "mt-1", "mb-0"]], template: function EditPortfolioConfirmationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, EditPortfolioConfirmationDetailsComponent_Conditional_0_Template, 2, 1, "div", 0)(1, EditPortfolioConfirmationDetailsComponent_Conditional_1_Template, 4, 3, "div", 1);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.details().error ? 0 : 1);
    } }, encapsulation: 2, changeDetection: 0 });
